export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

export const cognitoConfig = {
  userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
  clientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID
};

export const auth0Config = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN
};

export const mapConfig = process.env.REACT_APP_MAP_MAPBOX;

export const googleAnalyticsConfig = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const baseUrlWhatsApp = 'https://wa.me/5551991629970'

//----------------------------------------------------------
// export const api_agyx = 'http://localhost:4100'
// export const api_agyx = 'http://api.dev.agyx.com.br'
export const api_agyx = 'https://api.agyx.com.br'

//----------------------------------------------------------
// export const base_url = 'http://localhost:3000';
// export const base_url = 'http://cliente.dev.agyx.com.br';
export const base_url = 'https://cliente.agyx.com.br';

//----------------------------------------------------------
// export const base_url_vendedor = 'http://localhost:3000';
// export const base_url_vendedor = 'http://vendedor.dev.agyx.com.br';
export const base_url_vendedor = 'https://vendedor.agyx.com.br';

export const APP_VERSION = 'v1.5.1';